import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useApp } from '../context/AppContext';
import './Disclaimer.css';

const Disclaimer = () => {
  const navigate = useNavigate();
  const { user } = useApp();

  // Redirect to login if not authenticated
  useEffect(() => {
    const jwt = localStorage.getItem('jwt');
    if (!jwt) {
      navigate('/login');
    }
  }, [navigate]);

  const handleAccept = () => {
    localStorage.setItem('disclaimerAccepted', 'true');
    navigate('/home');
  };

  const handleDecline = () => {
    localStorage.removeItem('jwt');
    localStorage.removeItem('disclaimerAccepted');
    navigate('/login');
  };

  return (
    <div className="disclaimer-page">
      <div className="disclaimer-container">
        <div className="logo">
          <img src="/assets/loginassets/COLA_interface_LogIn_LOGO-03.svg" alt="COLA Logo" />
        </div>
        
        <div className="disclaimer-content">
          <h2>Legal Disclaimer</h2>
          <p className="disclaimer-text">
            THE FOLLOWING COLA SERVICE WAS PREPARED BY CORREGGIONET FOR THE PURPOSE OF A FREE TRIAL USING ALL REASONABLE CARE. HOWEVER, CORREGGIONET, ITS STAFF, OR COUNSEL INVOLVED IN ITS PREPARATION SHALL NOT BE LIABLE OR OTHERWISE RESPONSIBLE FOR ITS USE AND ANY DAMAGES OR LOSSES RESULTING OUT OF ITS USE IN ANY INDIVIDUAL CASE AND IN ANY JURISDICTION. IT IS THE RESPONSIBILITY OF EACH COLA TRIAL-USER TO ENSURE THAT THE SYSTEM IS NOT USED IN THE CONTEXT OF COMMERCIAL TRANSACTIONS. THE CONTENT UNDERLYING THE COLA SYSTEM HAS BEEN CREATED BY CORREGGIONET AND DOES NOT CONSTITUTE LEGAL ADVICE. COLA-USERS ACKNOLEDGE TO USE INFORMATION PROVIDED COLA ONLY FOR INFORMATIVE PURPOSES IN THE CONTEXT OF THIS FREE TRIAL
          </p>
          
          <p className="disclaimer-agreement">
            By clicking "I Accept" below, you acknowledge that you have read, understood, and agree to the terms of this disclaimer.
          </p>
          
          <div className="disclaimer-actions">
            <button className="decline-button" onClick={handleDecline}>Decline</button>
            <button className="accept-button" onClick={handleAccept}>I Accept</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
